import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "apps/messenger/components/MainWindow/Banners/Banner.scss";

const MessengerBanner = ({ children, danger }) => (
	<div className={classnames("messenger-banner", {
		"messenger-banner--danger": danger,
	})}>
		{children}
	</div>
);

MessengerBanner.propTypes = {
	children: PropTypes.node.isRequired,
	danger: PropTypes.bool,
};

MessengerBanner.defaultProps = {
	danger: false,
};

export default MessengerBanner;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/Banners/Banner.jsx